import pjson from '../package.json';
// Environmental settings
// set global fetch prep function
// disable logs for prod


console.log('version', pjson.version);

export default function envFunc() {
  const env = process.env.VITE_CUSTOM_ENV || 'local';
  console.log('ENV', env);
  console.log('HOST URL', process.env.VITE_REST_API_HOST);
  if (env === 'prod' || env === 'uat' || env === 'demo') {
    // eslint-disable-next-line
        console = console || {};
    // eslint-disable-next-line func-names
    console.log = function () {};
    // eslint-disable-next-line func-names
    console.warn = function () {};
    // eslint-disable-next-line func-names
    console.error = function () {};
    // eslint-disable-next-line func-names
    console.time = function () {};
    // eslint-disable-next-line func-names
    console.timeEnd = function () {};
  }
}
